export const actionTypes = {
  GET_ACCOUNT_BALANCE_LIST: "GET_ACCOUNT_BALANCE_LIST",
  GET_ACCOUNT_BALANCE_DETAILS: "GET_ACCOUNT_BALANCE_DETAILS",
  SET_ACCOUNT_BALANCE_LIST: "SET_ACCOUNT_BALANCE_LIST",
  SET_ACCOUNT_BALANCE_DETAILS: "SET_ACCOUNT_BALANCE_DETAILS"
};

export const actions = {
  getAccountBalanceList: (payload) => ({
    type: actionTypes.GET_ACCOUNT_BALANCE_LIST,
    payload: payload,
  }),

  getAccountBalanceDetails: (payload) => ({
    type: actionTypes.GET_ACCOUNT_BALANCE_DETAILS,
    payload: payload,
  }),
  setAccountBalanceList: (payload) => ({
    type: actionTypes.SET_ACCOUNT_BALANCE_LIST,
    payload: payload,
  }),

  setAccountBalanceDetails: (payload) => ({
    type: actionTypes.SET_ACCOUNT_BALANCE_DETAILS,
    payload: payload,
  })
};
